import { useState, useEffect } from "react";
import {
    loadWarehouseTypeList,
    loadWarehousetypeListByStatus,
} from "../../services/warehouseService";

const useWarehouseTypeList = (status, editID) => {
    const [warehouseTypes, setWarehouseTypes] = useState([]);
    const [selectedWarehouseType, setSelectedWarehouseType] = useState(null);
    const [selectedWarehouseTypeID, setSelectedWarehouseTypeID] = useState(null);
    const [isWarehouseTypeDataLoaded, setIsWarehouseTypeDataLoaded] = useState(false);

    const fetchWarehouseTypeList = async (selectedID = null) => {
        try {
            let data = [];

            // 🔹 Step 1: Try to load by status (active/inactive)
            if (status !== null) {
                const para = {
                    p_company_id: localStorage.getItem("companyid"),
                    p_plant_id: 1,
                    p_status: status,
                };
                data = await loadWarehousetypeListByStatus(para);
            } else {
                data = await loadWarehouseTypeList({
                    p_companyid: localStorage.getItem("companyid"),
                });
            }

            // 🔹 Step 2: Fallback — if no active found, load all
            if ((!data || data.length === 0) && status === true && selectedID) {
                data = await loadWarehouseTypeList({
                    p_companyid: localStorage.getItem("companyid"),
                });
            }

            // 🔹 Step 3: Continue like before
            if (data && data.length > 0) {
                let updatedList = [...data];
                let initialType = data.find((t) => t.warehouse_type_id === selectedID);

                if (!initialType && selectedID) {
                    const allData = await loadWarehouseTypeList({
                        p_companyid: localStorage.getItem("companyid"),
                    });
                    const inactiveType = allData.find((t) => t.warehouse_type_id === selectedID);
                    if (inactiveType) {
                        updatedList.push(inactiveType);
                        initialType = inactiveType;
                    }
                }

                setWarehouseTypes(updatedList);
                if (initialType) {
                    setSelectedWarehouseType(initialType);
                    setSelectedWarehouseTypeID(initialType.warehouse_type_id);
                }

                setIsWarehouseTypeDataLoaded(true);
            }

            else {
                setSelectedWarehouseType(null);
                setSelectedWarehouseTypeID(null);
                setWarehouseTypes([]);
                setIsWarehouseTypeDataLoaded(true);
            }
        } catch (error) {
            console.error("Error fetching warehouse types:", error);
        }
    };

    useEffect(() => {
        if (!isWarehouseTypeDataLoaded && editID === 0) {
            fetchWarehouseTypeList();
        }
    }, [isWarehouseTypeDataLoaded, editID]);

    const loadWarehouseTypeByID = async (selectedID) => {
        await fetchWarehouseTypeList(selectedID);
    };

    return {
        warehouseTypes,
        selectedWarehouseType,
        selectedWarehouseTypeID,
        setSelectedWarehouseType,
        setSelectedWarehouseTypeID,
        setIsWarehouseTypeDataLoaded,
        loadWarehouseTypeByID,
    };
};

export default useWarehouseTypeList;
